import { render, staticRenderFns } from "./CreateNotification.vue?vue&type=template&id=5463931e&"
import script from "./CreateNotification.vue?vue&type=script&lang=js&"
export * from "./CreateNotification.vue?vue&type=script&lang=js&"
import style0 from "./styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports